import React, { useMemo, useCallback, memo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Icon, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useNewAppointment } from '../../context';
import useStyles from './styles';

const SendError = () => {
  const classes = useStyles();
  const {
    infos: {
      limitConsultant: { periodType },
    },
    new: {
      error: { type: errorType, message: errorMessage },
    },
  } = useSelector(state => state.appointments);
  const history = useHistory();

  const { sendNewAppointment } = useNewAppointment();

  const goToSchedule = useCallback(() => {
    history.push('/appointments/new');
  }, [history]);

  const goToHome = useCallback(() => {
    history.push('/');
  }, [history]);

  const getAppointmentsPeriod = useMemo(() => {
    switch (periodType) {
      case 'day':
        return 'diário';
      case 'week':
        return 'semanal';
      case 'month':
        return 'mensal';
      case 'only once':
      default:
        return '';
    }
  }, [periodType]);

  const error = useMemo(() => {
    switch (errorType) {
      case 'LIMIT_EXCEEDED':
        return {
          message: `${errorMessage} ${getAppointmentsPeriod}.`,
          buttonText: 'Escolher outro horário',
          buttonAction: goToSchedule,
        };
      case 'TIME_NOT_EXISTS':
      case 'NOT_AVAILABLE_TIME':
      case 'TIME_IS_BEFORE_NOW':
        return {
          message: errorMessage,
          buttonText: 'Escolher outro horário',
          buttonAction: goToSchedule,
        };
      case 'WITHOUT_PERMISSION':
        return {
          message: errorMessage,
          buttonText: 'Voltar para o início',
          buttonAction: goToHome,
        };
      default:
        return {
          message: errorMessage,
          buttonText: 'Tentar novamente',
          buttonAction: sendNewAppointment,
        };
    }
  }, [
    errorType,
    errorMessage,
    getAppointmentsPeriod,
    goToSchedule,
    goToHome,
    sendNewAppointment,
  ]);

  return (
    <Box className={classes.container}>
      <Typography className="send-error-title" variant="h6">
        Ops!
      </Typography>
      <Icon className="send-error-icon" color="inherit">
        event_busy
      </Icon>
      <Typography className="send-error-message" variant="body2">
        {error.message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className="send-error-button"
        onClick={error.buttonAction}
      >
        {error.buttonText}
      </Button>
    </Box>
  );
};

export default memo(SendError);
